const WIDGET_IDS = [
    'carrotquest-messenger-collapsed-container',
    'carrotquest-messenger-frame',
    'carrotquest-css',
    'proxy-iframe',
]

export function useExternalScripts() {
    function loadDashly() {
        if (import.meta.env.VITE_NODE_ENV === 'local') return
        if (typeof window.dashly !== 'undefined') return

        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = 'https://cdn.dashly.app/api.min.js'
        document.head.appendChild(script)

        window.dashly = {}
        window.dashlyasync = []
        window.dashly.settings = {}

        const methods = ['connect', 'track', 'identify', 'auth', 'onReady', 'addCallback', 'removeCallback', 'trackMessageInteraction']
        methods.forEach((method) => {
            window.dashly[method] = function (...args) {
                window.dashlyasync.push(method, args)
            }
        })

        window.dashly.connect('7615-d66ac8523a19eae831fef1a5d82')
    }

    function unloadDashly() {
        WIDGET_IDS.forEach((id) => document.getElementById(id)?.remove())

        delete window.dashly
        delete window.dashlyasync
    }

    return { loadDashly, unloadDashly }
}
